import * as React from 'react';
export const mandiriSvg = React.forwardRef(function mandiriSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0D2B5B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.886 14.258c-.671-.763-1.385-.417-1.952-.136-.239.117-1.961 1.09-1.961 1.09-.944.387-1.679-.036-1.967-.392a.834.834 0 0 1-.074-.107l-.068-.116a5.23 5.23 0 0 0-.377-.563 3.189 3.189 0 0 0-.272-.31c-.646-.649-1.678-1.103-3.402-.278-.817.472-3.477 1.986-3.477 1.986-1 .41-1.764-.09-2.013-.456a.263.263 0 0 1-.029-.044l-.033-.055-.168-.275a4.638 4.638 0 0 0-.244-.35 3.51 3.51 0 0 0-.273-.308c-.64-.646-1.667-1.1-3.377-.29l-3.438 1.958-.001.001L3 16.615l.91 1.114c.384.364 1.104.96 2.218.457l3.087-1.78c2.63-1.436 3.926-.063 4.5.852.02.029.036.06.054.087l.001.002.018.032.065.106c.28.422.72.694 1.245.682.29-.006.487-.1.773-.259l2.975-1.719.007-.003c2.662-1.455 3.98.008 4.544.924.044.079.094.154.145.225.279.377.664.624 1.152.611.323-.006.685-.199.74-.234L29 15.66s-.363-.548-1.114-1.403Z',
      fill: '#FDD213',
    }),
  );
});
mandiriSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mandiri = {
  category: 'brand',
  colorable: false,
  name: 'mandiri',
  svg: mandiriSvg,
};
